import { Button } from "@base-ui/react/button";

export function Hero() {
  return (
    <section className="pt-32 pb-20 px-6">
      <div className="max-w-6xl mx-auto text-center">
        <h1 className="text-4xl sm:text-6xl font-bold text-primary-darker leading-tight">
          Manage your club,
          <br />
          not spreadsheets.
        </h1>
        <p className="mt-6 text-lg text-gray-500 max-w-2xl mx-auto">
          Cobble is the all-in-one member management platform built for student
          clubs and small organizations.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button
            render={<a href="#" />}
            nativeButton={false}
            className="px-6 py-3 rounded-lg bg-primary text-white font-medium hover:bg-primary-hover transition-colors"
          >
            Get started for free
          </Button>
          <Button
            render={<a href="#features" />}
            nativeButton={false}
            className="px-6 py-3 rounded-lg border border-gray-300 text-gray-700 font-medium hover:border-gray-400 transition-colors"
          >
            See features
          </Button>
        </div>
        <div className="mt-16 max-w-4xl mx-auto border-2 border-dashed border-gray-300 rounded-2xl h-80 flex items-center justify-center">
          <span className="text-gray-400 text-sm">
            Dashboard screenshot coming soon
          </span>
        </div>
      </div>
    </section>
  );
}
